/*
 * @Author: 张帮辉
 * @LastEditors: 彭鑫诚
 * @Date: 2022-02-23 20:11:57
 * @LastEditTime: 2024-07-17 11:31:38
 * @Description: file content
 */
import type {
  IRequestOrderModel,
  IRequestOrderStore,
} from '@monorepo/types/orders/requestOrder/requestOrder.types';
import { tableUpdate } from '@monorepo/utils';
import { getToday } from '@monorepo/utils';

const initState: IRequestOrderStore = {
  isInit: true,
  tableList: [],
  total: 0,
  query: {
    pageSize: 50,
    page: 1,
    date_type: 'CREATED_DATE',
    sort_order: 'CREATED_DESC',
    date: getToday(),
    order_state: '',
  },
  total_money: '0',
  total_use_unit_qty: '0',
  auditNo: '',
  cachePath: '/',
  autoQuery: false,
};

const requestOrderStore: IRequestOrderModel = {
  namespace: 'requestOrderStore',
  state: initState,
  reducers: {
    save(state, action) {
      return {
        ...state,
        ...action.payload,
      };
    },
    updateTableList(state, { payload }) {
      const tableList = tableUpdate(state.tableList, payload.data, payload.auditNo);
      return {
        ...state,
        tableList,
      };
    },
    resetInit() {
      return { ...initState };
    },
  },
};

export default requestOrderStore;
